
function BigUp({ width = 24, height = 24, color = "#DEDEDE" }) {
	return (
		<svg height={height} width={width} viewBox="0 0 24 9" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M23 8L12 2L1 8" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
		</svg>
	);
}

export default BigUp;
